<template>
  <div class="team-selector-player text-center" :style="position">
    <div v-if="player === null">
      <img class="team-selector-player-image"
           :src="require('./images/Player Icons/Pick Player icon.png')"/>
    </div>
    <div v-if="player !== null">
      <img class="team-selector-player-image" :src="player.badgeUrl" crossorigin="anonymous"/>
      <div class="team-selector-player-number">{{player.number}}</div>
      <div class="team-selector-player-name d-flex justify-content-center"><span class="first-name">{{player.firstName}}</span> <span
        class="last-name">{{player.lastName}}</span></div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'TeamPlayer',
  props: {
    player: {
      type: Object,
      default () {
        return null
      }
    },
    x: {
      type: String,
      default () {
        return '50%'
      }
    },
    y: {
      type: String,
      default () {
        return '50%'
      }
    }
  },
  data: function () {
    return {}
  },
  computed: {
    position: function () {
      return `position: absolute; left: ${(this.x)}; top: ${(this.y)};`
    }
  },
  methods: {}
}
</script>
